module.exports = __webpack_public_path__ + "static/media/logoColegio.90f1c007.png";